import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '../../queryKeys';
import { vin } from '../Vin';

export const useVinPositions = (selectedVin?: string) =>
  useQuery({
    queryKey: [QUERY_KEYS.vesselPositions, selectedVin],
    queryFn: async () => (await vin.getVinPositions(selectedVin)).data,
    enabled: !!selectedVin,
  });
